import * as R from "ramda";
import React, { Component } from "react";
import FlexView from "react-flexview";
import ModalContainer from "../../../../../modules/commons/ModalContainer";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import SimpleAlert from "../../../../../modules/popup/SimpleAlert";
import SimpleLoadingOverlay from "../../../../../modules/popup/SimpleLoadingOverlay";
import SimpleModal from "../../../../../modules/popup/SimpleModal";
import Api from "../../../../../Services/Api";
import { getValueFromDDL, mapToObjectDDL } from "../../../../common/mapper";
import MutasiBarangDetailInputs from "./mutasiBarangDetailInputs";
import MutasiBarangDetailTabs from "./mutasiBarangDetailTabs";
import { ACTIVITY_TYPE, HttpStatus } from "../../../../common/Constants";
import M from 'moment';
import { fetchDataAsync } from "../../../../../Services/Utils";

class MutasiBarangDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            firstLoad: true,
            alertVisible: false,
            loading: false,
            alertInformation: null,
            deleteAlertVisible: null,
            data: {
                mutationDate: M(new Date()).format("DD-MM-YYYY"),
                mutationSourceKodeLocator: null,
            },
            errorData: null,
            cabangOptions: [],
            locatorSourceOptions: [],
            locatorTargetOptions: [],
            kodeVarianOptions: [],
            kodeKSUOptions: [],
            kodeHadiahOptions: [],
            warnaOptions: [],
            kodeBarangLainOptions: [],
            activityType: null,
            isRejectAllAction: false,
            anyByPassScanner: false,
        };
    }

    async componentDidMount() {
        this.setState((prevValue) => ({ ...prevValue, loading: true }));
        let response;
        let muNo;
        if (this.props.state.id) {
            response = await this.props.tab.getById(this.props.state.id, this.props.setError)
        } else {
            muNo = await Api.create("NAGAMAS_MASTER_DATA").getGenSeqWithoutSave({
                seqType: "MutationParent",
                nosDealerCode: this.props.kodeCabang.value,
                transactionType: "MutationParent"
            })
        }
        const responses = await Promise.all([
            Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang(),
            Api.create("NAGAMAS_MASTER_DATA").getAllMasterLocationPagingByParam({
                paramFilters: { kodeCabang: this.props.kodeCabang.value },
            }),
            Api.create("NAGAMAS_MASTER_DATA").getAllVariant(),
            Api.create("NAGAMAS_MASTER_DATA").getAllKSU(),
            Api.create("NAGAMAS_MASTER_DATA").getAllHadiah(),
            Api.create("NAGAMAS_MASTER_DATA").getAllWarna(),
            Api.create("NAGAMAS_MASTER_DATA").getAllOtherItemPagingByParam({
                paramFilters: {},
            }),
        ]);

        if (responses[0].ok && !R.isEmpty(responses[0].data.data)) {
            this.setState((prevValue) => ({
                ...prevValue,
                cabangOptions: responses[0].data.data.map((c) => mapToObjectDDL(c.namaDealer, c.kodeCabang)),
            }));
        }

        if (responses[1].ok && !R.isEmpty(responses[1].data.data)) {
            this.setState((prevValue) => ({
                ...prevValue,
                locatorSourceOptions: responses[1].data.data.map((l) =>
                    mapToObjectDDL(l.nameLocation, l.kodeLocation)
                ),
            }));
        }

        if (responses[2].ok && !R.isEmpty(responses[2].data.data)) {
            this.setState((prevValue) => ({
                ...prevValue,
                kodeVarianOptions: responses[2].data.data.map((kv) => ({
                    label: kv.kodeVariant,
                    value: kv.kodeVariant,
                    nosin: null,
                    noka: null,
                    namaVariant: kv.namaVariant,
                })),
            }));
        }

        if (responses[3].ok && !R.isEmpty(responses[3].data.data)) {
            this.setState((prevValue) => ({
                ...prevValue,
                kodeKSUOptions: responses[3].data.data.map((ksu) => ({
                    label: ksu.kodeKSU,
                    value: ksu.kodeKSU,
                    category: ksu.category,
                    name: ksu.name,
                    satuan: ksu.satuan,
                })),
            }));
        }

        if (responses[4].ok && !R.isEmpty(responses[4].data.data)) {
            this.setState((prevValue) => ({
                ...prevValue,
                kodeHadiahOptions: responses[4].data.data.map((h) => ({
                    label: h.kodeHadiah,
                    value: h.kodeHadiah,
                    name: h.nameHadiah,
                    category: h.categoryHadiah,
                    satuan: h.satuanHadiah,
                    qrHadiah: h.qrHadiah,
                })),
            }));
        }

        if (responses[5].ok && !R.isEmpty(responses[5].data.data)) {
            this.setState((prevValue) => ({
                ...prevValue,
                warnaOptions: responses[5].data.data,
            }));
        }

        if (responses[6].ok && !R.isEmpty(responses[6].data.data)) {
            this.setState((prevValue) => ({
                ...prevValue,
                kodeBarangLainOptions: responses[6].data.data.map((bl) => ({
                    label: bl.kodeotheritem,
                    value: bl.kodeotheritem,
                    name: bl.nameotheritem,
                    category: bl.categoryotheritem,
                    satuan: bl.satuanotheritem,
                    qrotheritem: bl.qrotheritem
                })),
            }));
        }

        if (response?.ok && response?.data?.status === HttpStatus.SUCCESS) {
            const data = response.data.data;

            const res = await Api.create("NAGAMAS_MASTER_DATA").getAllMasterLocationPagingByParam({
                paramFilters: { kodeCabang: data.mutationTargetKodeCabang },
            });
            const res2 = await Api.create("NAGAMAS_MASTER_DATA").getAllMasterLocationPagingByParam({
                paramFilters: { kodeCabang: data.mutationSourceKodeCabang },
            });
            const locOptions2 = res2.data.data.map((l) =>
                mapToObjectDDL(l.nameLocation, l.kodeLocation))
            const locOptions = res.data.data.map((l) =>
                mapToObjectDDL(l.nameLocation, l.kodeLocation)
            );
            this.setState((prevValue) => ({
                ...prevValue,
                activityType: ACTIVITY_TYPE.UPDATE,
                locatorTargetOptions: res.data.data.map((l) =>
                    mapToObjectDDL(l.nameLocation, l.kodeLocation)
                ),
                data: {
                    ...prevValue.data,
                    ...data,
                    mutationSourceKodeCabang: this.state.cabangOptions.find((c) =>
                        R.equals(c.value, data.mutationSourceKodeCabang)
                    ),
                    mutationTargetKodeCabang: this.state.cabangOptions.find((c) =>
                        R.equals(c.value, data.mutationTargetKodeCabang)
                    ),
                    mutationSourceKodeLocator: locOptions2.find((c) =>
                        R.equals(c.value, data.mutationSourceKodeLocator)
                    ),
                    mutationTargetKodeLocator: data.mutationTargetKodeLocator
                        ? locOptions.find((c) =>
                            R.equals(c.value, data.mutationTargetKodeLocator)
                        )
                        : null,
                    mutationUnits: !R.isEmpty(data.mutationUnits)
                        ? data.mutationUnits.map((mu) => {
                            const variantValue = this.state.kodeVarianOptions.find((kv) =>
                                R.equals(kv.value, mu.kodeVariant)
                            );
                            const warnaValue = this.state.warnaOptions.find((w) =>
                                R.equals(w.id, mu.kodeWarna)
                            );

                            return {
                                ...mu,
                                noka: mu.frameNumber,
                                nosin: mu.engineNumber,
                                kodeVariant: variantValue ? { ...variantValue } : null,
                                kodeWarna: warnaValue ? {
                                    value: warnaValue.id,
                                    label: warnaValue.namaWarnaKomersil
                                } : null,
                                saved: true,
                                scanned: false,
                                checked: false,
                            };
                        })
                        : [],
                    mutationKsus: !R.isEmpty(data.mutationKsus)
                        ? data.mutationKsus.map((mk) => {
                            const kodeKsuValue = this.state.kodeKSUOptions.find((k) =>
                                R.equals(k.value, mk.kodeKsu)
                            );
                            return {
                                ...mk,
                                kodeKsu: kodeKsuValue ? { ...kodeKsuValue } : null,
                                categoryKsu: mk.categoryKsu?.value,
                                qty: 1,
                                saved: true,
                                scanned: false,
                                checked: false,
                            };
                        })
                        : [],
                    mutationGifts: !R.isEmpty(data.mutationGifts)
                        ? data.mutationGifts.map((mg) => {
                            const kodeHadiahValue = this.state.kodeHadiahOptions.find((kh) =>
                                R.equals(kh.value, mg.masterGiftDTO.kodeHadiah)
                            );
                            return {
                                ...mg,
                                oldQty: R.equals(data?.mutationStatus, "NEW") ? 0 : mg.qty,
                                kodeHadiah: kodeHadiahValue ? { ...kodeHadiahValue } : null,
                                satuan: kodeHadiahValue.satuan,
                                saved: true,
                                scanned: false,
                                status: data.mutationStatus || null,
                            };
                        })
                        : [],
                    mutationGiftBarcodes: !R.isEmpty(data.mutationGiftBarcodes)
                        ? data.mutationGiftBarcodes.map((mgb) => {
                            const kodeHadiahValue = this.state.kodeHadiahOptions.find((kh) =>
                                R.equals(kh.value, mgb.masterGiftDTO.kodeHadiah)
                            );
                            return {
                                ...mgb,
                                kodeHadiah: kodeHadiahValue ? { ...kodeHadiahValue } : null,
                                qty: 1,
                                satuan: kodeHadiahValue.satuan,
                                saved: true,
                                scanned: false,
                                checked: false,
                            };
                        })
                        : [],
                    mutationOthers: !R.isEmpty(data.mutationOthers)
                        ? data.mutationOthers.map((mo) => {
                            const kodeOtherItem = this.state.kodeBarangLainOptions.find((kbl) =>
                                R.equals(kbl.value, mo.masterOtherItemDTO.kodeOtherItem)
                            );

                            return {
                                ...mo,
                                oldQty: R.equals(data?.mutationStatus, "NEW") ? 0 : mo.qty,
                                satuan: kodeOtherItem.satuan,
                                kodeOtherItem: kodeOtherItem ? { ...kodeOtherItem } : null,
                                saved: true,
                                scanned: false,
                                status: data.mutationStatus || null,
                            };
                        })
                        : [],
                    mutationOtherBarcodes: !R.isEmpty(data.mutationOtherBarcodes)
                        ? data.mutationOtherBarcodes.map((mob) => {
                            const kodeOtherItem = this.state.kodeBarangLainOptions.find((kbl) =>
                                R.equals(kbl.value, mob.masterOtherItemDTO.kodeOtherItem)
                            );
                            return {
                                ...mob,
                                satuan: kodeOtherItem.satuan,
                                kodeOtherItem: kodeOtherItem ? { ...kodeOtherItem } : null,
                                qty: 1,
                                saved: true,
                                scanned: false,
                                checked: false,
                            };
                        })
                        : [],
                },
            }));
        } else {
            this.setState((prevValue) => ({
                ...prevValue,
                activityType: ACTIVITY_TYPE.CREATE,
                data: {
                    ...prevValue.data,
                    mutationNo: muNo.data,
                    mutationSourceKodeCabang: this.state.cabangOptions.find((c) =>
                        R.equals(c.value, this.props.kodeCabang.value)),
                    mutationUnits: [],
                    mutationKsus: [],
                    mutationGifts: [],
                    mutationGiftBarcodes: [],
                    mutationOthers: [],
                    mutationOtherBarcodes: [],
                }
            }))
        }
        this.setState((prevValue) => ({ ...prevValue, loading: false }));
    }

    async componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState.data.mutationTargetKodeCabang !== this.state.data.mutationTargetKodeCabang) {
            if (!R.isNil(this.state.data.mutationTargetKodeCabang?.value)) {
                const res = await Api.create("NAGAMAS_MASTER_DATA").getAllMasterLocationPagingByParam({
                    paramFilters: { kodeCabang: this.state.data.mutationTargetKodeCabang.value },
                })
                this.setState((prevValue) => ({
                    ...prevValue,
                    locatorTargetOptions: res.data.data.map((l) =>
                        mapToObjectDDL(l.nameLocation, l.kodeLocation)
                    ),
                    data: {
                        ...prevValue.data,
                        mutationTargetKodeLocator: this.state.firstLoad ? this.state.data.mutationTargetKodeLocator : null,
                    }
                }))
            }
        }
    }

    handleSubmit = async () => {
        this.saveDetail();
    };

    handleProcess = () => {
        const userId = localStorage.getItem("userId");
        console.log(userId, 'userId')
        this.saveDetail("WAITING_APPROVAL", userId);
    };

    handleReset = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            alertTitle: "Warning",
            deleteAlertVisible: !prevValue.deleteAlertVisible,
        }));
    };

    handleSubmitDelete = async () => {
        const mutationStatus = this.state.data.mutationStatus
        if (mutationStatus === "PROCESSED") {
            return this.setState(prev => ({
                ...prev,
                alertTitle: null,
                deleteAlertVisible: false,
                alertInformation: {
                    error: true,
                    content: <p>Mutasi tidak dapat dihapus karna sudah dilakukan proses pada mutasi masuk.<br />Silahkan lakukan proses Mutasi keluar pada mutasi masuk.</p>
                }
            }))
        }

        this.setState({ loading: true })
        const res = await this.props.tab.delete(this.state.data.mutationNo, this.props.setError)
        this.setState({ loading: false })
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            this.handleReset();
            this.props.onRefresh();
            this.props.onClickClose();
            this.setState((prevValue) => ({ ...prevValue, alertInformation: null }));
            return
        }
        if (!res.ok && res.data?.message?.startsWith("Mutasi tidak dapat dihapus")) {
            this.setState(prev => ({
                ...prev,
                alertTitle: null,
                deleteAlertVisible: false,
                alertInformation: {
                    error: true,
                    content: <p>{res.data?.message}</p>
                }
            }))
            return
        }
    };

    handleStateChange = (callback) => {
        this.setState(callback);
    };

    handleAlertVisibility = () => {
        console.log(!this.state.alertInformation.error)
        if (!this.state.alertInformation.error) {
            this.props.onRefresh();
            this.props.onClickClose();
        }
        this.setState((prevValue) => ({ ...prevValue, alertInformation: null }));
    };

    checkByPassScanBeforeProcess = () => {
        // if (!this.props.mutasiKeluarTab && this.anyUnchecked(this.state.data)) {
        //     this.setState((prevValue) => ({
        //         ...prevValue,
        //         loading: false,
        //         alertInformation: {
        //             error: true,
        //             content: (
        //                 <div>
        //                     <p>Ada field data yang perlu diisi atau tidak sesuai kriteria isian. yahud</p>
        //                     <br/>
        //                     <p>Mohon periksa kembali.</p>
        //                 </div>
        //             ),
        //         },
        //     }));
        //     return true;
        // }

        if (!this.props.mutasiKeluarTab && !this.state.anyByPassScanner && this.anyByPassScanner(this.state.data)) {
            this.setState((prevState) => ({
                ...prevState,
                loading: false,
                anyByPassScanner: true,
                alertTitle: "Proses Terima Mutasi",
                warningMessage: "Proses mutasi masuk bypass Scan QR. Apakah ingin meminta Approval?",
            }))
            this.handleAlertModalVisibility(false, true);
            return true;
        }

        return false;
    }

    anyUnchecked = (formValues) => {
        const anyUnCheckedUnit = !R.isEmpty(formValues.mutationUnits)
            ? formValues.mutationUnits.some((mu) => mu.checked === false && mu.status !== "REJECTED")
            : false;

        const anyUnCheckedKsu = !R.isEmpty(formValues.mutationKsus)
            ? formValues.mutationKsus.some((mk) => mk.checked === false && mk.status !== "REJECTED")
            : false;

        const anyUnCheckedGift = !R.isEmpty(formValues.mutationGiftBarcodes)
            ? formValues.mutationGiftBarcodes.some((mgb) => mgb.checked === false && mgb.status !== "REJECTED")
            : false;

        const anyUnCheckedOther = !R.isEmpty(formValues.mutationOtherBarcodes)
            ? formValues.mutationOtherBarcodes.some((mob) => mob.checked === false && mob.status !== "REJECTED")
            : false;

        return anyUnCheckedUnit || anyUnCheckedKsu || anyUnCheckedGift || anyUnCheckedOther;
    }

    anyByPassScanner = (formValues) => {
        const anyByPassUnit = !R.isEmpty(formValues.mutationUnits)
            ? formValues.mutationUnits.some((mu) => mu.scanned === false && mu.status !== "REJECTED")
            : false;

        const anyByPassKsu = !R.isEmpty(formValues.mutationKsus)
            ? formValues.mutationUnits.some((mk) => mk.scanned === false && mk.status !== "REJECTED")
            : false;

        const anyByPassGift = !R.isEmpty(formValues.mutationGiftBarcodes)
            ? formValues.mutationGiftBarcodes.some((mgb) => mgb.scanned === false && mgb.status !== "REJECTED")
            : false;

        const anyByPassOther = !R.isEmpty(formValues.mutationOtherBarcodes)
            ? formValues.mutationOtherBarcodes.some((mob) => mob.scanned === false && mob.status !== "REJECTED")
            : false;

        return anyByPassUnit || anyByPassKsu || anyByPassGift || anyByPassOther;
    }

    validDetail = (formValues) => {
        const isValidMutationUnits = !R.isEmpty(formValues.mutationUnits)
            ? formValues.mutationUnits.every((mu) => mu.kodeVariant !== "" && mu.kodeWarna !== "" && mu.engineNumber !== "")
            : true;

        let isValidMutationGifts;
        let isValidMutationOthers;
        if (this.props.mutasiKeluarTab) {
            isValidMutationGifts = !R.isEmpty(formValues.mutationGifts)
                ? formValues.mutationGifts.every((mg) => mg.kodeHadiah !== "" && mg.qty >= 1)
                : true;
            isValidMutationOthers = !R.isEmpty(formValues.mutationOthers)
                ? formValues.mutationOthers.every((mo) => mo.kodeOtherItem !== "" && mo.qty >= 1)
                : true;
        } else {
            isValidMutationGifts = !R.isEmpty(formValues.mutationGifts)
                ? formValues.mutationGifts.every((mg) => mg.kodeHadiah !== "" && !R.isNil(mg.receivedQty))
                : true;
            isValidMutationOthers = !R.isEmpty(formValues.mutationOthers)
                ? formValues.mutationOthers.every((mo) => mo.kodeOtherItem !== "" && !R.isNil(mo.receivedQty))
                : true;
        }

        const isValidMutationGiftsBarcodes = !R.isEmpty(formValues.mutationGiftBarcodes)
            ? formValues.mutationGiftBarcodes.every((mgb) => mgb.kodeHadiah !== "" && mgb.otherBarcode !== "")
            : true;

        const isValidMutationOthersBarcodes = !R.isEmpty(formValues.mutationOtherBarcodes)
            ? formValues.mutationOtherBarcodes.every((mob) => mob.kodeOtherItem !== "" && mob.otherBarcode !== "")
            : true;

        return !isValidMutationUnits || !isValidMutationGifts || !isValidMutationOthers || !isValidMutationGiftsBarcodes || !isValidMutationOthersBarcodes;
    };

    saveDetail = async (status = "NEW", userId = null) => {
        this.setState((prevValue) => ({ ...prevValue, loading: true }));
        const data = this.state.data;
        const formValues = {
            ...data,
            kodeCabang: getValueFromDDL(data, "mutationSourceKodeCabang"),
            problem: data?.problem || false,
            mutationNo: this.state.activityType === ACTIVITY_TYPE.CREATE ? "" : this.state.data.mutationNo,
            mutationStatus: status,
            mutationSourceKodeCabang: getValueFromDDL(data, "mutationSourceKodeCabang"),
            mutationTargetKodeCabang: getValueFromDDL(data, "mutationTargetKodeCabang"),
            mutationSourceKodeLocator: getValueFromDDL(data, "mutationSourceKodeLocator"),
            mutationTargetKodeLocator: getValueFromDDL(data, "mutationTargetKodeLocator"),
            mutationUnits: data.mutationUnits
                .filter((mu) => mu.saved)
                .map((mu) => ({
                    engineNumber: mu.nosin || "",
                    frameNumber: mu.noka || "",
                    kodeVariant: mu.kodeVariant?.value || "",
                    kodeWarna: mu.kodeWarna?.value || "",
                    ...(this.props.mutasiKeluarTab ? {} : { status: !mu.scanned && mu.status === "ONPROGRESS" ? "RECEIVED" : mu.status, scanned: mu.scanned || false }),
                    ...(this.props.mutasiKeluarTab ? {} : { variantName: mu.variantName })
                })),
            mutationKsus: data.mutationKsus
                .filter((mk) => mk.saved)
                .map((mk) => {
                    let tempStatus;

                    if (!this.props.mutasiKeluarTab) {
                        if (mk?.status === "RECEIVED") {
                            tempStatus = "RECEIVED";
                        } else {
                            tempStatus = "REJECT";
                        }
                    } else {
                        if (
                            mk?.status &&
                            ["REJECT", "RECEIVED"].includes(mk?.status)
                        ) {
                            tempStatus = mk.status;
                        } else {
                            tempStatus = "ONPROGRESS";
                        }
                    }
                    return {
                        kodeKsu: mk.kodeKsu?.value || "",
                        ksuBarcode: mk?.ksuBarcode || "",
                        ksuName: mk?.nameKsu || "",
                        status: tempStatus,
                        ...(this.props.mutasiKeluarTab ? {} : { status: !mk.scanned && mk.status === "ONPROGRESS" ? "RECEIVED" : mk.status, scanned: mk.scanned || false }),
                    }
                }),
            mutationGifts: data.mutationGifts
                .filter((mg) => mg.saved)
                .map((mg) => ({
                    kodeHadiah: mg.kodeHadiah?.value || "",
                    qty: mg.qty,
                    receivedQty: mg.receivedQty,
                })),
            mutationGiftBarcodes: data.mutationGiftBarcodes
                .filter((mgb) => mgb.saved)
                .map((mgb) => ({
                    giftBarcode: mgb?.otherBarcode || "",
                    namaHadiah: mgb?.kodeHadiah?.name || "",
                    kodeHadiah: mgb.kodeHadiah?.value || "",
                    ...(this.props.mutasiKeluarTab ? {} : { status: !mgb.scanned && mgb.status === "ONPROGRESS" ? "RECEIVED" : mgb.status, scanned: mgb.scanned || false }),
                })),
            mutationOthers: data.mutationOthers
                .filter((mo) => mo.saved)
                .map((mo) => ({
                    kodeOtherItem: mo.kodeOtherItem?.value || "",
                    qty: mo.qty,
                    receivedQty: mo.receivedQty,
                    otherItemName: mo.masterOtherItemDTO?.nameOtherItem || ""
                })),
            mutationOtherBarcodes: data.mutationOtherBarcodes
                .filter((mob) => mob.saved)
                .map((mgb) => ({
                    otherItemName: mgb?.masterOtherItemDTO?.nameOtherItem || "",
                    otherBarcode: mgb?.otherBarcode || "",
                    kodeOtherItem: mgb.kodeOtherItem?.value || "",
                    ...(this.props.mutasiKeluarTab ? {} : { status: !mgb.scanned && mgb.status === "ONPROGRESS" ? "RECEIVED" : mgb.status, scanned: mgb.scanned || false }),
                })),
        };

        if (userId) {
            formValues.userId = userId;
        }

        let validHeaderInput = true;
        this.setState((prevState) => ({ ...prevState, errorData: {} }))
        if (!this.props.mutasiKeluarTab) {
            if (!formValues.mutationTargetKodeLocator) {
                validHeaderInput = false;
                this.setState((prevValue) => ({
                    ...prevValue,
                    loading: false,
                    alertInformation: {
                        error: true,
                        content: (
                            <div>
                                <p>
                                    Locator Penerima tidak ditemukan, harap pilih Locator
                                    Penerima.
                                </p>
                            </div>
                        ),
                    },
                }));
                return;
            }
        }

        if (
            !formValues.mutationSourceKodeCabang ||
            !formValues.mutationTargetKodeCabang ||
            !formValues.mutationSourceKodeLocator ||
            this.validDetail(this.state.data)
        ) {
            this.setState((prevValue) => ({
                ...prevValue,
                loading: false,
                alertInformation: {
                    error: true,
                    content: (
                        <div>
                            <p>Ada field data yang perlu diisi atau tidak sesuai kriteria isian. gacor</p>
                            <br />
                            <p>Mohon periksa kembali.</p>
                        </div>
                    ),
                },
            }));
            return;
        }

        if (this.checkByPassScanBeforeProcess() || !validHeaderInput) {
            return;
        }

        formValues.qty =
            formValues.mutationUnits.length +
            formValues.mutationOthers.length +
            formValues.mutationOtherBarcodes.length +
            formValues.mutationKsus.length +
            formValues.mutationGifts.length +
            formValues.mutationGiftBarcodes.length;

        if (formValues.qty === 0 && this.props.mutasiKeluarTab) {
            this.setState((prevValue) => ({
                ...prevValue,
                loading: false,
                alertInformation: {
                    error: true,
                    content: (
                        <div>
                            <p>
                                Tidak terdapat data pada tabel Mutasi Keluar, Silahkan tambahkan data telebih dahulu !
                            </p>
                        </div>
                    ),
                },
            }));
            return;
        }

        const renamedFormValues = Object.entries(formValues).reduce((obj, [key, value]) => {
            let newKey = key;
            if (key === "mutationUnits") {
                newKey = "mutationUnit";
            } else if (key === "mutationKsus") {
                newKey = "mutationKsu";
            } else {
                newKey = key;
            }
            obj[newKey] = value;
            return obj;
        }, {});

        let title;
        let alertMessage;
        let funcSubmit = "create"

        if (this.props.mutasiKeluarTab) {
            title = status === "NEW" ? "Simpan Data Mutasi" : "Proses Data Mutasi";
            alertMessage = status === "NEW" ? "Data mutasi barang keluar berhasil disimpan."
                : "Data mutasi barang keluar berhasil diproses untuk request Approval.";
            if (status === 'WAITING_APPROVAL') {
                funcSubmit = 'update'
            }
        } else {
            title = this.state.anyByPassScanner ? "Proses Terima Mutasi" : "Proses Data Mutasi";
            alertMessage = this.state.anyByPassScanner ? "Permintaan Approval telah dikirimkan. Mohon menunggu Approval."
                : "Data mutasi barang masuk berhasil diproses.";
        }

        const response = await this.props.tab[funcSubmit](renamedFormValues, this.props.setError);

        if (response.ok && response.data.status === HttpStatus.SUCCESS) {
            this.setState((prevValue) => ({
                ...prevValue,
                anyByPassScanner: false,
                alertInformation: {
                    error: false,
                    title: title,
                    content: <p>{alertMessage}</p>,
                },
            }));
        }
        this.setState({ loading: false });
    };

    additionalButton = () => {
        if (this.props.state.buttonType === 'preview') {
            return null;
        }
        if (this.props.mutasiKeluarTab) {
            if (this.props.state.buttonType === "delete") {
                return <SimpleButton onClick={this.handleReset}>Hapus</SimpleButton>
            }
            return (
                <>
                    {/* <SimpleButton secondary onClick={this.handleReset}>Hapus</SimpleButton> */}
                    <SimpleButton onClick={this.handleSubmit}>Simpan</SimpleButton>
                    <SimpleButton onClick={this.handleProcess}>Proses</SimpleButton>
                </>
            )
        }

        return (
            <>
                <SimpleButton onClick={this.handleProcess}>Proses</SimpleButton>
                <SimpleButton onClick={this.handleAlertRejectAll}>Reject All</SimpleButton>
            </>
        )
    }

    handleAlertModalVisibility = (isRejectAllAction = false, anyByPassScanner = false) => {
        this.setState((prevState) => ({
            ...prevState,
            isRejectAllAction: isRejectAllAction,
            anyByPassScanner: anyByPassScanner,
            alertVisible: !prevState.alertVisible,
        }))
    }

    handleAlertRejectAll = () => {
        if (!this.props.mutasiKeluarTab) {
            if (
                R.isNil(this.state.data.mutationTargetKodeLocator) ||
                R.isEmpty(this.state.data.mutationSourceKodeLocator)
            ) {
                this.setState((prevValue) => ({
                    ...prevValue,
                    loading: false,
                    alertInformation: {
                        error: true,
                        content: (
                            <div>
                                <p>
                                    Locator Penerima tidak ditemukan, harap pilih Locator
                                    Penerima.
                                </p>
                            </div>
                        ),
                    },
                }));
                return;
            }
        }
        this.setState((prevState) => ({
            ...prevState,
            alertTitle: "Proses Mutasi Ditolak",
            warningMessage: "Data mutasi barang masuk akan ditolak dan prosesnya tidak bisa dibatalkan. Apakah anda yakin?",
        }))
        this.handleAlertModalVisibility(true, false);
    }

    render() {
        return (
            <>
                <SimpleModal
                    title={this.props.mutasiKeluarTab ? "Mutasi Keluar" : "Mutasi Masuk"}
                    visible={this.props.state.detailVisible}
                    onClickClose={this.props.onClickClose}
                    content={
                        <ModalContainer>
                            <MutasiBarangDetailInputs
                                state={this.state}
                                errorData={this.state.errorData}
                                buttonType={this.props.state.buttonType}
                                mutasiKeluarTab={this.props.mutasiKeluarTab}
                                onSetState={this.handleStateChange}
                            />
                            <MutasiBarangDetailTabs
                                state={this.state}
                                buttonType={this.props.state.buttonType}
                                onSetState={this.handleStateChange}
                                mutasiKeluarTab={this.props.mutasiKeluarTab}
                            />
                            <FlexView vAlignContent="center" hAlignContent="right" className="margin-top-15px">
                                {this.additionalButton()}
                            </FlexView>
                        </ModalContainer>
                    }
                />
                {this.state.loading && <SimpleLoadingOverlay active={this.state.loading} />}
                {this.state.alertInformation !== null && (
                    <SimpleAlert
                        visible={this.state.alertInformation !== null}
                        title={this.state.alertInformation.title || "Information"}
                        onClickClose={this.handleAlertVisibility}
                        content={
                            <div>
                                {this.state.alertInformation.content}
                                <SimpleButton
                                    className="margin-left-none margin-top-15px"
                                    onClick={this.handleAlertVisibility}
                                >
                                    OK
                                </SimpleButton>
                            </div>
                        }
                    />
                )}
                {this.state.deleteAlertVisible && (
                    <SimpleAlert
                        visible={this.state.deleteAlertVisible}
                        title={this.state.alertTitle || "Information"}
                        onClickClose={this.handleReset}
                        content={
                            <div>
                                <p>Data Mutasi akan dihapus. Apakah anda yakin?</p>
                                <FlexView hAlignContent="center">
                                    <SimpleButton className="margin-top-15px" onClick={this.handleReset}>
                                        Batal
                                    </SimpleButton>
                                    <SimpleButton
                                        className="margin-left-none margin-top-15px"
                                        onClick={this.handleSubmitDelete}
                                    >
                                        Ya
                                    </SimpleButton>
                                </FlexView>
                            </div>
                        }
                    />
                )}
                {this.state.alertVisible && (
                    <SimpleAlert
                        title={this.state.alertTitle || "Information"}
                        content={
                            <div>
                                <p>
                                    {this.state.warningMessage}
                                </p>
                            </div>
                        }
                        visible={this.state.alertVisible}
                        onClickClose={this.handleAlertModalVisibility}
                        additionalButtons={
                            (this.state.isRejectAllAction) ?
                                <FlexView hAlignContent={"right"} vAlignContent={"center"}>
                                    <SimpleButton
                                        secondary
                                        type="button"
                                        text="Batal"
                                        onClick={() => this.handleAlertModalVisibility()}
                                    />
                                    <SimpleButton
                                        type="button"
                                        text="Reject"
                                        onClick={() => this.props.handleRejectAll(this.state.data)}
                                    />
                                </FlexView> :
                                (this.state.anyByPassScanner) ?
                                    <FlexView hAlignContent={"right"} vAlignContent={"center"}>
                                        <SimpleButton
                                            secondary
                                            type="button"
                                            text="Batal"
                                            onClick={() => this.handleAlertModalVisibility()}
                                        />
                                        <SimpleButton
                                            type="button"
                                            text="Ya"
                                            onClick={() => {
                                                this.setState((prevValue) => ({
                                                    ...prevValue,
                                                    alertVisible: !prevValue.alertVisible,
                                                }))
                                                this.handleProcess();
                                            }}
                                        />
                                    </FlexView> :
                                    <>
                                        <SimpleButton
                                            type="button"
                                            text="OK"
                                            onClick={() => this.handleAlertModalVisibility()}
                                        />
                                    </>

                        }
                    />
                )}
            </>
        );
    }
}

export default MutasiBarangDetail;
